import React from 'react';

interface PageNavigationProps {
  currentIndex: number;
  totalTasks: number;
  onPrevious: () => void;
  onNext: () => void;
  previousLabel?: string;
  nextLabel?: string;
  previousSubtitle?: string;
  nextSubtitle?: string;
}

const PageNavigation: React.FC<PageNavigationProps> = ({
  currentIndex,
  totalTasks,
  onPrevious,
  onNext,
  previousLabel = 'Previous Task',
  nextLabel = 'Next Task',
  previousSubtitle = '',
  nextSubtitle = '',
}) => {
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === totalTasks - 1;

  const showPrevious = !isFirst;
  const showNext = !isLast;
  const onlyOne = showPrevious !== showNext;

  const alignmentClass = onlyOne
    ? showPrevious
      ? 'align-left'
      : 'align-right'
    : 'align-both';

  return (
    <div className={`page-navigation-container ${alignmentClass}`}>
      {showPrevious && (
        <div className={`single-button-wrapper ${onlyOne ? 'align-left' : ''}`}>
          <button className="nav-button previous" onClick={onPrevious}>
            <div className="nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
                <path d="M23.2188 9L1.71875 9" stroke="#7B7E89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.71875 17L1.71875 9L9.71875 0.999999" stroke="#7B7E89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="nav-text-block">
              <div className="nav-title">{previousLabel}</div>
              <div className="nav-subtitle">{previousSubtitle}</div>
            </div>
          </button>
        </div>
      )}

      {showNext && (
        <div className={`single-button-wrapper ${onlyOne ? 'align-right' : ''}`}>
          <button className="nav-button next" onClick={onNext}>
            <div className="nav-text-block">
              <div className="nav-title">{nextLabel}</div>
              <div className="nav-subtitle">{nextSubtitle}</div>
            </div>
            <div className="nav-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
                <path d="M1.21875 9H22.7187" stroke="#7B7E89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.7188 1L22.7188 9L14.7188 17" stroke="#7B7E89" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default PageNavigation;
